/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The request to update a notification registration status
 */
export interface NotificationRegistrationStatusUpdateRequest { 
    /**
     * The status of the notification registration
     */
    notificationRegistrationStatus: string;
}
